module.exports = __webpack_public_path__ + "static/img/aiMakeup.2b93ea3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ai_beauty/aiMakeup.png
// module id = lbpl
// module chunks = 1